<script lang="ts" setup>
const { locale, setLocale } = useI18n()
const { locales } = useAppConfig()
const userStore = useUserStore()

const currentLocale = computed(() => {
  return locales.find(item => item.code === locale.value)
})

async function onChangeLocale(newLocale: typeof locales[0]) {
  const newLocaleCode = newLocale.code as Locale

  if (userStore.user) {
    await userStore.updateUser({ locale: newLocaleCode })
  }

  setLocale(newLocaleCode)
}
</script>

<template>
  <USelectMenu
    class="w-16"
    :model-value="locale"
    option-attribute="label"
    :options="locales"
    size="lg"
    :ui="{
      color: { white: { outline: 'cursor-pointer transition ring-gray-200 dark:ring-gray-800 hover:ring-gray-300 dark:hover:ring-gray-700' } },
      base: '!bg-gray-50 dark:!bg-gray-950',
      padding: { md: 'px-2' },
      icon: { trailing: { padding: { lg: 'pr-1.5' } } },
    }"
    :ui-menu="{
      container: '!w-36',
      popper: {
        placement: 'top-end',
      },
    }"
    @change="onChangeLocale"
  >
    <template #label>
      <UIcon
        class="w-4.5 ml-0.5 flex-shrink-0"
        :name="currentLocale?.icon || ''"
      />
    </template>

    <template #option="{ option }">
      <UIcon
        class="ml-0.5 w-5"
        :name="option.icon"
      />

      {{ option.name }}
    </template>
  </USelectMenu>
</template>
